export const environment = {
	production: false,
	API_URL: 'https://nm9h6mb148.execute-api.ap-south-1.amazonaws.com/dev/'
};